<infl-widget-wrapper [widget]="widget()" [actions]="actions">
  <div class="wrapper">
    <ul>
      <li>
        <label>{{ 'i18n.common.user' | translate }}</label
        >: {{ user() }}
      </li>
      @for (info of infos(); track info.key) {
        <li>
          <label>{{ info.key }}</label
          >: {{ info.value }}
        </li>
      }
    </ul>
  </div>
</infl-widget-wrapper>
